<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Form Wizard with icon</h3>
      </div>
      <div class="card-body">
        <form-wizard @on-complete="onComplete">
          <tab-content title="Registration"  icon="fa fa-user">
            <div class="col-xs-12" >
            <personal />
          </div>
          </tab-content>
          <tab-content title="Email"  icon="fa fa-gear">
            <div class="col-xs-12 text-start" >
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label">Email</label>
                <input class="form-control" type="email" placeholder="name@example.com" required="required" />
              </div>
              <div class="form-group">
                <label class="control-label">Password</label>
                <input class="form-control" type="password" placeholder="Password" required="required" />
              </div>
            </div>
          </div>
          </tab-content>
          <tab-content title="Birth Date" icon="fa fa-twitter">
            <div class="col-xs-12 text-start" >
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label">Birth date</label>
                <input class="form-control" type="date" required="required" />
              </div>
              <div class="form-group">
                <label class="control-label">Have Passport</label>
                <input class="form-control" type="text" placeholder="yes/No" required="required" />
              </div>
            </div>
          </div>
            </tab-content>
        </form-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import personal from "./personalPage1.vue";
import { FormWizard, TabContent } from "vue3-form-wizard";
import 'vue3-form-wizard/dist/style.css'
export default {
  name: "App",
  components: {
    FormWizard,
    TabContent,
    personal,
  },
  data() {
    return {
      currentTabIndex: 0,
    };
  },
  methods: {
    onChangeCurrentTab(index) {

      this.currentTabIndex = index;
    },
   
  },
};
</script>